module.exports = __webpack_public_path__ + "img/newicon8click.4314b0b9.svg";